import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { URLS } from '../../../shared/constants/urls.constant';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { PaypalInfoDialogBuilder } from './paypal-info-dialog.builder';

export const DIALOG_TYPE = 'paypal-info';

@Component({
  selector: 'app-paypal-info-dialog',
  templateUrl: './paypal-info-dialog.component.html',
  styleUrls: ['./paypal-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [PaypalInfoDialogBuilder],
})
export class PaypalInfoDialogComponent implements OnInit {
  @Input() country: string;
  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  dialogType: string;
  confirmUrl: string;
  introLabel: string;
  listItems: List<string>;
  trackingObject: ITrackingObject;
  trackingScreenName: TrackingScreenNamesEnum;

  constructor(private _paypalInfoDialogBuilder: PaypalInfoDialogBuilder) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.confirmUrl = URLS.PAYMENTS_HELP_PAYPAL_TRANSACTION_FEES;
    this.listItems = this._paypalInfoDialogBuilder.buildListItems(this.country);
    this.introLabel = this._paypalInfoDialogBuilder.buildIntroLabel(
      this.country
    );
  }
}
